import { GUI } from "dat.gui";
import { Mesh, TextureLoader } from "three";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { imgsT5 } from "../../../../assets/imgs/Tema5";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../assets/models/subtopicthree/GLB_Monitor_V4.glb";


const images = {
	's1_m1': imgsT5.sub1_monitor1,
	's1_m2': imgsT5.sub1_monitor2,
	's1_m3': imgsT5.sub1_monitor3,
	's1_m4': imgsT5.sub1_monitor4,
	's1_m5': imgsT5.sub1_monitor5,
	's1_m6': imgsT5.sub1_monitor6,
	's1_m7': imgsT5.sub1_monitor7,
	's1_m8': imgsT5.sub1_monitor8,
	's1_m9': imgsT5.sub1_monitor9,
	's1_m10': imgsT5.sub1_monitor10,

	's2_m1': imgsT5.sub2_monitor1,
	's2_m2': imgsT5.sub2_monitor2,
	's2_m3': imgsT5.sub2_monitor3,
	's2_m4': imgsT5.sub2_monitor4,

	's3_m1': imgsT5.sub3_monitor1,
	's3_m2': imgsT5.sub3_monitor2,
	's3_m3': imgsT5.sub3_monitor3,
	's3_m4': imgsT5.sub3_monitor4,
	's3_m5': imgsT5.sub3_monitor5,
	's3_m6': imgsT5.sub3_monitor6,
	's3_m7': imgsT5.sub3_monitor7,
	's3_m8': imgsT5.sub3_monitor8,
	's3_m9': imgsT5.sub3_monitor9,
	's3_m10': imgsT5.sub3_monitor10,

	's4_m1': imgsT5.sub4_monitor1,
	's4_m2': imgsT5.sub4_monitor2,
	's4_m3': imgsT5.sub4_monitor3,
	's4_m4': imgsT5.sub4_monitor4,
	's4_m5': imgsT5.sub4_monitor5,
	's4_m6': imgsT5.sub4_monitor6,
	's4_m7': imgsT5.sub4_monitor7,
	's4_m8': imgsT5.sub4_monitor8,
	's4_m9': imgsT5.sub4_monitor9,
	's4_m10': imgsT5.sub4_monitor10,
	's4_m11': imgsT5.sub4_monitor11,
	's4_m12': imgsT5.sub4_monitor12,
	's4_m13': imgsT5.sub4_monitor13,
	's4_m14': imgsT5.sub4_monitor14,
	's4_m15': imgsT5.sub4_monitor15,
	's4_m16': imgsT5.sub4_monitor16,

}

export class Monitor extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.listenersobserver();
		// this.helpers()
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Monitor = gltf.scene.getObjectByName("Monitor", true);
			this.Pantalla = gltf.scene.getObjectByName("Pantalla", true);
			this.Plano = gltf.scene.getObjectByName("Plano", true);
			this.initMonitor();
		});
	}

	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.Plano;
		object.material.map = newTexture
		object.material.toneMapped = false;
	}

	listenersobserver() {
		ObserverEmitter.on(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, (image) => {
			this.updateMaterialScreen(images[image])
		});
	}

	initMonitor() {
		this.position.set(-11.4, -0.226, 2.7)
		this.rotation.y = 1.6
		this.scale.set(2, 2);
		this.Pantalla.scale.set(0.96, 1.2, 0.8) // monitor rectagular
		this.updateMaterialScreen(imgsT5.sub1_monitor1);
	}
	helpers() {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("Monitor");
		const limit = 20;
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this, "visible").name("Visible");

		folderMostrador
			.addColor({ color: this.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				this.material.color.set(value);
			});
	}
}
